import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import Colors from "../../../ui/global/Colors";
import Fonts from "../../../ui/global/Fonts";
import Button from "../../../ui/components/Button";
import Tooltip from "../../../ui/components/Tooltip";
import InputSimple from "../../../ui/components/InputSimple";
import { useNavigate } from "react-router-dom";
import ProfileButton from "../../shared/ProfileButton";
import { useConfig } from "../../../utils/config";

const TopContainer = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0;
    margin: 0;
    // border-bottom: 1px solid ${Colors.grey1};
`;

const Toolbar = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: fit-content;
    margin: 0;
    padding: 0 5px 5px 5px;
    gap: 10px;
    z-index: 100;
    overflow: visible;
`;

const Left = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    margin: 0;
`;

const Middle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex: 1;
    gap: 6px;
    margin: 0;
`;

const Right = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    margin: 0;
`;

const Divider = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Colors.grey1};
    width: 1px;
    height: 24px;
    margin: auto;
`;

const Name = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-family: ${Fonts.lexendSemiLight.fontFamily};
    font-weight: ${Fonts.lexendSemiLight.fontWeight};
    font-size: 16px;
    line-height: 1.2em;
    background-color: ${Colors.transparent};
    color: ${Colors.black};
    border: 1px solid ${Colors.transparent};
    text-wrap: nowrap;
    border-radius: 8px;
    // margin: 10px;

    &:hover {
        background-color: ${Colors.white};
        border: 1px solid ${Colors.grey1};
    }
`;

interface ToolbarTopProps {
    soundId: string;
    initialName: string;
}

const ToolbarTop = ({ soundId, initialName }: ToolbarTopProps) => {
    const config = useConfig();
    const navigate = useNavigate();
    const [soundName, setSoundName] = useState(initialName);
    const soundNameTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        setSoundName(initialName);
    }, [initialName]);

    const onHomeClick = () => {
        // navigate('/art');
    };

    const onNameChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const currentValue = e.target.value; // Capture the current value
        setSoundName(currentValue);
        console.log('Input changed to:', currentValue);
    };

    const renderLeft = () => {
        return (
            <Left>
                <Tooltip text="Home" colorMode="dark">
                    <Button 
                        size="small" 
                        color="ghost" 
                        icon="home" 
                        onClick={onHomeClick}
                    />
                </Tooltip>
                {/* <Divider /> */}
                <Name>
                    <InputSimple
                        value={soundName}
                        colorMode='light'
                        textAlign='left'
                        onChange={(e) => onNameChange(e)}
                        onEnterPress={() => {}}
                    />
                </Name>
            </Left>
        )
    };

    const renderMiddle = () => {
        return (
        <>
            {/* <Divider /> */}
            <Middle>
                
            </Middle>
            {/* <Divider /> */}
        </>
        )
    };

    const renderRight = () => {
        return (
            <Right>
                {/* <Button 
                    size="small" 
                    color="ghost" 
                    icon="more" 
                    onClick={()=>{}}
                /> */}
                <ProfileButton config={config} colorMode="light" />
            </Right>
        )
    };

    return (
        <TopContainer>
            <Toolbar id='toolbar-top'>
                {renderLeft()}
                {window.innerWidth > 768 && renderMiddle()}
                {renderRight()}
            </Toolbar>
        </TopContainer>
    );
};

export default ToolbarTop;